/**
 * Media utilities - Single source of truth for media extensions, type detection, and codecs.
 *
 * @module media
 */

// Extension registry
export {
    // Image extensions
    IMAGE_EXTENSIONS,
    IMAGE_TRANSCODER_EXTENSIONS,
    IMAGE_DECODER_EXTENSIONS,
    IMAGE_RAW_EXTENSIONS,

    // Audio extensions
    AUDIO_EXTENSIONS,
    AUDIO_TRANSCODER_EXTENSIONS,
    AUDIO_DECODER_EXTENSIONS,

    // Video extensions
    VIDEO_EXTENSIONS,
    VIDEO_TRANSCODER_EXTENSIONS,
    VIDEO_DECODER_EXTENSIONS,

    // Document & other extensions
    ARCHIVE_EXTENSIONS,
    DOCUMENT_EXTENSIONS,
    EBOOK_EXTENSIONS,
    PRESENTATION_EXTENSIONS,
    VECTOR_EXTENSIONS,
    PDF_EXTENSIONS,
    PS_EXTENSIONS,
    MS_OFFICE_EXTENSIONS,

    // Aggregated sets
    ALL_EXTENSIONS,
    ALL_EXTENSIONS_SET,
    THUMBNAIL_SUPPORTED_EXTENSIONS,
    THUMBNAIL_SUPPORTED_EXTENSIONS_SET,
    DISALLOWED_EXTENSIONS,

    // Types
    type ImageExtension,
    type AudioExtension,
    type VideoExtension,
    type ArchiveExtension,
    type DocumentExtension,
    type AllExtension,
} from './media-extensions';

// Media type detection
export {
    isVideoToType,
    isAudioToType,
    isImageToType,
    isVideoFromType,
    isAudioFromType,
    isImageFromType,
    detectMediaType,
    isVideoExtension,
    isAudioExtension,
    isImageExtension,
} from './media-type-detector';

// Codec resolution
export {
    getVideoCodecForExtension,
    getAudioCodecForExtension,
    getCodecsForVideoContainer,
    isVideoCodecSupported,
    isAudioCodecSupported,
    DEFAULT_VIDEO_CODEC,
    DEFAULT_AUDIO_CODEC,
} from './codec-resolver';
